import React, { useEffect, useReducer } from 'react';
import ActionLink from '../builder/ActionLink';
import { getRemotedbUrl, i18nIntl } from '../../lib/ep';
import Spinner from '../builder/Spinner';
import FloatingLayerPublic from './FloatingLayerPublic';
import MediaGalleryItemSelector from '../ui_items/MediaGalleryItemSelector';
import { FormattedMessage } from 'react-intl';

const reducer = (state, action) => {
	switch(action.type) {
		case 'CHANGE':
			return {
				...state,
				[action.k]:action.v,
			};

		case 'SET_LOGGED':
			return {
				...state,
				logged:action.logged,
				loading:false,
				loading_posts:true,
				display_layer:true,
			};

		case 'TOGGLE_LAYER':
			return {
				...state,
				display_layer:!state.display_layer,
				selecteds:[],
			};

		case 'TOGGLE_LOADING':
			return {
				...state,
				loading:!state.loading,
			};

		case 'SET_MEDIA':
			const _media = action?.media ?? [];

			return {
				...state,
				loading_posts:false,
				posts:_media.elements,
				next_cursor:_media?.next ?? null, 
				prev_cursor:_media?.previous ?? null,
				page_number:state.page_number + (action?.direction ?? 0),
			};

		default:
			return state;
	}
};

const Wrapper = ({ state, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const hashtags = props?.hashtags ?? [];
	const has_username = props.type != 'tiktok';
	return (
		<>
			{(state.logged) && (
				<>
					<p dangerouslySetInnerHTML={{ __html:props.intl.formatMessage({id:"Logged as {username}"}, {username:`<strong>${has_username ? '@':''}${state.logged.username}</strong>`})}}></p>
					<p class="gui_not_in_top_tiny">
					{(props.hashtags.length > 0) ? (
						<FormattedMessage id="{link} that contains {label}" values={{ link:<ActionLink _class={{other:"gui_not_uppercase"}} onClick={() => props.dispatch({ type:'TOGGLE_LAYER' })}>Select a post</ActionLink>, label:hashtags.join(` ${i18n("or")} `) }} />
					) : (
						<ActionLink _class={{other:"gui_not_uppercase"}} onClick={() => props.dispatch({ type:'TOGGLE_LAYER' })}>Select a post</ActionLink>
					)}
					</p>
					
				</>
			)} 
			{props.children}
		</>
	)
};

const SocialMediaSelector = (props) => {

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const max_pages = 3;

	const promotion = props.promotion;
	const stage = props.stage;

	const type = props?.type ?? 'instagram';
	const limit = props?.limit ?? false;

	const is_builder = props?.is_builder ?? false;
	const fake_user_token = props?.fake_user_token ?? false;

	const hashtags = (stage[`media_${type}_hashtags`] != undefined) ? stage[`media_${type}_hashtags`].map(hashtag => hashtag.toLowerCase()) : [];

	const local_stagorage_key = `user${(promotion.id != undefined) ? '_'+promotion.id:''}${(stage.id != undefined) ? '_'+stage.id:''}`
	const data_storage = {user:props?.user ?? null,medias:props.medias}

	const [ state, dispatch ] = useReducer(reducer, {
		loading:false,
		loading_posts:false,
		//logged:null,
		logged:(fake_user_token !== false) ? fake_user_token : null,
		posts:[],
		page_number:1,
		next_cursor:null,
		prev_cursor:null,
		no_more_calls:false,
		selecteds:[],
		display_layer:false,
	});

	const connect = (social) => {
		const promo = (promotion.id != undefined) ? `?pid=${promotion.id}` : '';
		const st = (stage.id != undefined) ? `&stage=${stage.id}` : '';
		let url_login = `/social_login/${social}${promo}${st}`;

		if(data_storage && window.localStorage != undefined){//Save as Local Storage
			window.localStorage.setItem(local_stagorage_key, JSON.stringify(data_storage));
		}

		$.get(getRemotedbUrl(url_login), (resp) => {
			if(resp.status == 0) {
				if(resp.error)window.location.reload()
				if(resp.url)window.location.href = resp.url;
			} else {
				if(cb != undefined) cb({ customResponse:resp });
			}
		}, 'JSON');
	};

	useEffect(() => {
		const params = new URLSearchParams(new URL(window.location.href).search);
		const social = params.get('social');
		if(social == undefined) return;
		
		let url_login = `/social_login/${social}`;
		const cache_id = params.get('sid');
		if(cache_id) url_login += `?sid=${cache_id}`;

		dispatch({
			type:'TOGGLE_LOADING',
		});

		$.get(getRemotedbUrl(url_login), (response) => {
			if(response.status == 1) {
				dispatch({
					type:'SET_LOGGED',
					logged:response,
				});
				if(window.localStorage != undefined && props.callback != undefined){
					let data = JSON.parse(window.localStorage.getItem(local_stagorage_key));
					props.callback(data);
					setTimeout(()=>{
						window.localStorage.removeItem(local_stagorage_key);
					},100);
				}
			} else {
				dispatch({
					type:'TOGGLE_LOADING',
				});
			}
		}, 'JSON');
	}, []);

	useEffect(() => {
		if(!state.logged) return;
		getMedia();
	}, [ state.logged ]);

	const getMediaURL = (direction = 1) => {
		const url_media = [`/utils/${type}_media/${state.logged.id}`];
		if(state.next_cursor || state.prev_cursor) {
			url_media.push(`/${direction}/${(direction > 0) ? state.next_cursor : state.prev_cursor}`);
		}
		url_media.push(`?token=${state.logged.access_token}`);
		if(limit !== false) url_media.push(`&limit=${limit}`);

		return getRemotedbUrl(url_media.join(""));
	};

	const getMedia = (direction) => {
		if(!((direction == undefined) || (state.page_number < max_pages && direction > 0) || (state.page_number > 1 && direction < 0))) return;

		dispatch({
			type:'CHANGE',
			k:'no_more_calls',
			v:false,
		});

		const url = getMediaURL();
		$.get(url, (media) => {
			if(hashtags.length > 0) {
				let match_elements = [];
				(media.elements).map((item) => {
					const lowerCaseStr = (item.name).toLowerCase();
					const found = hashtags.filter(hashtag => lowerCaseStr.includes(hashtag)).length > 0;
					if(found)match_elements.push(item);
				})
				media.elements = match_elements;
			} else if(media.elements.length == 0) {
				// reached the end of catalogue
				dispatch({
					type:'CHANGE',
					k:'no_more_calls',
					v:true,
				});
			}

			if(!state.no_more_calls) {
				dispatch({
					type:'SET_MEDIA',
					media:media,
					direction,
				});
			}
		}, 'JSON');
	};

	if(state.loading && !state.logged) {
		return (
			<div>
				<Spinner
					_class={{ other:'gui_pos_rel_important' }}
					force_bg={true}
					autotranslate={false}
				>{i18n("Connecting")}...</Spinner>
			</div>
		)
	}

	const label_network = {
		instagram:"Instagram",
		tiktok:"TikTok",
	};

	const only_public_videos = i18n("You can only select public videos.");

	let subtitle = false;
	let subtitle_no_posts = false;
	if(hashtags.length > 0) {
		subtitle = `${(hashtags.length > 1) ? i18n("hashtags",'c') : i18n("Hashtag")}: ${hashtags.join(` ${i18n("or")} `)}<br />${only_public_videos}`;
		subtitle_no_posts = `${props.intl.formatMessage({ id:"To participate, please publish a post with the {label}" }, { label:`${(hashtags.length > 1 ? i18n("hashtags") : i18n("Hashtag",'lowercase'))}: <strong>${hashtags.join(`</strong> ${i18n("or")} <strong>`)}</strong>`})}.<br />${only_public_videos}`;
	} else if(type == 'tiktok') {
		subtitle = only_public_videos;
		subtitle_no_posts = only_public_videos;
	}

	return (
		<Wrapper
			state={state}
			dispatch={dispatch}
			hashtags={hashtags}
			type={props.type}
			intl={props.intl}
		>
			{(!state.logged) && (
				<ActionLink
					_class={{ other:'logged_user gui_not_in_top_small' }}
					onClick={() => connect(type)}
					autotranslate={false}
				>{`${props.intl.formatMessage({ id:"Connect with {integration}" }, { integration:label_network[props.type]})}`}</ActionLink>
			)}
			
			{(state.display_layer) && (
				<FloatingLayerPublic
					pm={promotion}
					is_builder={is_builder}
					backButton={() => dispatch({ type:'TOGGLE_LAYER' })}
				>
					<MediaGalleryItemSelector
						type={type}
						title={i18n("Select a post")}
						subtitle={subtitle}
						title_no_post={i18n("No posts are available for selection.")}
						subtitle_no_posts={subtitle_no_posts}
						items={state?.posts ?? []}
						loading={state.loading_posts}
						onSelect={(selected) => {
							props.onSelect(selected);
							dispatch({ type:'TOGGLE_LAYER' });
						}}
						//prev_cursor={state.prev_cursor}
						//next_cursor={state.next_cursor}
						page_number={state.page_number}
						max_pages={max_pages}
						onPaginate={getMedia}
						max_items={props.max_elements}
					/>
				</FloatingLayerPublic>
			)}
		</Wrapper>
	);
}

export default SocialMediaSelector;